
























































// import Vue from 'vue'

import mixin from './mixin'

export default mixin.extend({
  data() {
    return {
      stackUID: '',
    }
  },

  methods: {
    copyLinkToClipboard() {
      /* Get the text field */
      // eslint-disable-next-line
      const copyText: any = document.getElementById('link-parameters')

      copyText.type = 'text'

      /* Select the text field */
      copyText.select()
      copyText.setSelectionRange(0, 99999) /* For mobile devices */

      /* Copy the text inside the text field */
      document.execCommand('copy')
      copyText.type = 'hidden'
    },
  },
})
